import { scrollToElementById } from './delayed-scroll.js';

/**
 * ドロワーメニューの開閉処理
 */
export function drawer() {
  const drawer = document.querySelector('.js-drawer');
  const trigger = document.querySelector('.js-drawer-trigger');
  const closeButton = document.querySelector('.js-drawer-close');
  const backdrop = document.querySelector('.js-drawer-backdrop');
  const hamburger = document.querySelector('.m-hamburger');

  if (!drawer || !trigger) {
    return;
  }

  // メニューを開く
  function openDrawer() {
    drawer.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    if (hamburger) {
      hamburger.setAttribute('aria-expanded', 'true');
    }
  }

  // メニューを閉じる
  function closeDrawer() {
    drawer.classList.remove('is-visible');
    document.body.style.overflow = '';
    if (hamburger) {
      hamburger.setAttribute('aria-expanded', 'false');
    }
  }

  // トリガーボタンのクリックイベント
  trigger.addEventListener('click', (e) => {
    e.preventDefault();
    if (drawer.classList.contains('is-visible')) {
      closeDrawer();
    } else {
      openDrawer();
    }
  });

  // 閉じるボタンのクリックイベント
  if (closeButton) {
    closeButton.addEventListener('click', (e) => {
      e.preventDefault();
      closeDrawer();
    });
  }

  // バックドロップのクリックイベント
  if (backdrop) {
    backdrop.addEventListener('click', () => {
      closeDrawer();
    });
  }

  // ドロワー内のアンカーリンク: クリックで閉じた後にアンカーへスクロール
  const DRAWER_CLOSE_DURATION_MS = 400;
  const drawerAnchorLinks = drawer.querySelectorAll('a[href*="#"]');
  drawerAnchorLinks.forEach((link) => {
    link.addEventListener(
      'click',
      (e) => {
        const href = link.getAttribute('href');
        const hashIndex = href.indexOf('#');
        if (hashIndex === -1) return;

        const targetId = href.substring(hashIndex);
        const targetElement = document.querySelector(targetId);
        if (!targetElement) return;

        e.preventDefault();
        e.stopImmediatePropagation();
        closeDrawer();
        setTimeout(() => {
          scrollToElementById(targetId);
        }, DRAWER_CLOSE_DURATION_MS);
      },
      true,
    );
  });

  // ESCキーで閉じる
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-visible')) {
      closeDrawer();
    }
  });
}
